<template>
    <CategoryListDialog
            :dialogTitle="'物料分类清单'"
            :centerDialogVisible="visible"
            @updateVisible="updateVisible"
            @resetPopupData="resetPopupData"
            @submitPopupData="submitPopupData"
            :popupWidth="'1000px'"
            :showBtn="false"
    >
        <div style="display: flex">
            <TableList
                    style="width: 50%"
                    :loading="loading2"
                    :table-data="tableData"
                    :table-label="tableLabel"
                    :index-show="false"
                    @handleButton="handleButton"
                    @handleSortChange="handleSortChange"
                    @handleSelectionChange="handleSelectionChange"
                    key="1"
            >
            </TableList>
            <TableList
                    style="width: 50%"
                    :loading="loading1"
                    :table-data="tableData1"
                    :table-label="tableLabel"
                    :index-show="false"
                    @handleButton="handleButton"
                    @handleSortChange="handleSortChange"
                    @handleSelectionChange="handleSelectionChange"
                    key="2"
            >
            </TableList>
        </div>

        <div class="pagination">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                           :page-sizes="[10, 20, 30, 40, 50, 60, 80, 100]" layout="total, sizes, prev, pager, next, jumper"
                           :current-page="pager.currentPage" :page-size="pager.pageSize"
                           :total="pager.pageTotal" prev-text="上一页" next-text="下一页">
            </el-pagination>
        </div>

        <div style="width: 100%; text-align: center;margin-top: 20px">
            <el-button @click="resetPopupData">关闭</el-button>
        </div>
    </CategoryListDialog>
</template>

<script>
    import CategoryListDialog from "../../../../../components/common/epecDialog";
    import TableList from "../../common/e-table-list";
    import agreementApi from "../../../api/agreement/index";
    export default {
        name: "categoryListDialog",
        components: {
            CategoryListDialog,
            TableList,
        },
        props: {
            visible: {
                type: Boolean,
                required: true,
            },
        agreementId:{
            type: String,
            required: true
        }
        },
        data() {
            return {
                loading1: false,
                loading2: false,
                tableData:[],
                tableLabel: [
                    { label: '序号', param: 'index', align: 'center',width:'50px'},
                    { label: '物料类别', param: 'categoryName', align: 'center'},
                ],
                pager:{
                    currentPage: 1,
                    pageSize: 20,
                    pageTotal:0
                },
                tableData1:[],
                dialogTitle: "物料分类清单",
            };
        },
        computed: {},
        created() {
            this.getSharedResourceMdmTypeList();
        },
        methods: {
            handleSearch() {
                this.getSharedResourceMdmTypeList();
            },
            handleSizeChange(val) {
                this.pager.currentPage = 1;
                this.pager.pageSize = val;
                this.getSharedResourceMdmTypeList();
            },
            handleCurrentChange(val) {
                this.pager.currentPage = val;
                this.getSharedResourceMdmTypeList();
            },
            updateVisible() {},
            resetPopupData() {
                this.$emit("close");
            },
            submitPopupData() {
                this.$emit('close')
            },
            async getSharedResourceMdmTypeList(){
                let params = {
                    agreementId:this.agreementId,
                    pageSize:this.pager.pageSize,
                    pageNum: this.pager.currentPage
                }
                this.tableData=[]
                this.tableData1=[]

                let res = await agreementApi.getSharedResourceMdmTypeList(params)

                        if(res.data){
                            this.loading1 = false
                            this.loading2 = false
                            for(let i=0;i<res.data.records.length;i++){
                                if((i+1) % 2 == 0){
                                    this.$set(res.data.records[i],'index', i+1)
                                    this.tableData1.push(res.data.records[i])
                                }else {
                                    this.$set(res.data.records[i],'index', i+1)
                                    this.tableData.push(res.data.records[i])
                                }
                            }

                        }
                         this.pager.pageTotal = res.data.total
            },
            handleButton(){
            },
            handleSortChange(){},
            handleSelectionChange(){},
        },
    };
</script>

<style lang="scss" scoped>
    .el-dialog {
        display: flex;
        flex-direction: column;
        margin: 0 !important;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        /*height:600px;*/
        max-height: calc(100% - 30px);
        max-width: calc(100% - 30px);
    }

    .el-dialog .el-dialog__body {
        flex: 1;
        overflow: auto;
    }
</style>
